import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSubscription, activateSubscription } from '../../services/api/licensingService';

export const loadSubscription = createAsyncThunk('licensing/load', async () => fetchSubscription());

export const activateLicense = createAsyncThunk('licensing/activate', async (signedEntitlement) => activateSubscription(signedEntitlement));

const licensingSlice = createSlice({
  name: 'licensing',
  initialState: { status: 'idle', error: null, subscription: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSubscription.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(loadSubscription.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.subscription = action.payload;
      })
      .addCase(loadSubscription.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(activateLicense.fulfilled, (state, action) => {
        state.subscription = action.payload;
      });
  }
});

export default licensingSlice.reducer;
